export const environment = {
	name: 'prod',
	production: true,
	host: 'https://dms.oktraffic.org/api/',
	deviceTypeNameIds: {
		messageSign: 1,
		portableSign: 2,
		weighStation: 11
	},
	signTypeIds: {
		weightStations: 10
	},
	azureAD: {
		msalConfig: {
			auth: {
				clientId: '179a97d6-9789-43d2-beb5-bbdc0cad3db7',
				authority: 'https://login.microsoftonline.com/9a307864-3e98-4f08-b90a-728b62cf32c5',
				redirectUri: 'https://dms.oktraffic.org/sso-login'
			}
		},
		loginRequest: {
			scopes: ['https://odot-dms-prod/read'],
			prompt: 'login'
		}
	}
};



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/environments/environment.ts